var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-account"},[(_vm.hasRegistrationTokenError)?_c('invalid-token-error'):_vm._e(),(!_vm.hasRegistrationTokenError)?_c('set-password-form'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }